/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, themeV2, coloredScrollBar } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  '@global': {
    '.modalpage': {
      borderRadius: pxToEm(12)
    },
    '.migrationmodal': {
      textAlign: 'center',
      overflowY: 'auto',
      extend: coloredScrollBar(themeV2.color.base.scrollbar),
      fontSize: pxToEm(14),
      padding: pxToEm(14),
      maxWidth: pxToEm(420),
    padding: `${pxToEm(8)} ${pxToEm(16)}`,
      '& button': { width: '100%'},
      '& h4': {
        marginBottom: pxToEm(20),
        fontSize: '16px',
        borderBottom: '3px solid #000',
        paddingBottom: pxToEm(8),
        textAlign: 'center',
        width: '100%',
        zIndex: 10
      },
      '& .changelist': {
        textAlign: 'left',
        margin: `${pxToEm(16)} ${pxToEm(24)}`,
      },
      '& ul': {
        margin: pxToEm(8),
        marginBottom: pxToEm(16),
        '& li': {
          textAlign: 'left',
          marginLeft: pxToEm(16)
        }
      },
      '& .errormessage': {
        display: 'block',
        color: themeV2.color.error.main
      },
      '& .tip': {
        color: themeV2.color.error.main
      }
    }
  }
});
